import React from 'react';
import { Container, Alert, Button } from 'react-bootstrap';
import { useAuth } from '@context';
import { canAccessAdminPanel } from '@utils/permissions';

/**
 * RequireAdmin Component
 * Restricts access to admin users (those with admin-level capabilities)
 * 
 * @param {Object} props
 * @param {React.ReactNode} props.children - Child components to render if authorized
 * @param {string} props.requiredCapability - Specific capability to require (optional)
 */
export function RequireAdmin({ children, requiredCapability = 'view_admin_panel' }) {
  const { user, loading } = useAuth();

  if (loading) {
    return null;
  }

  // Use the permission utility to check access
  const hasAccess = requiredCapability 
    ? canAccessAdminPanel(user)
    : (user?.role === 'admin' || user?.role === 'course_manager');

  if (!hasAccess) {
    return (
      <Container className="py-5">
        <Alert variant="danger" className="mb-3">
          Unauthorized: Admin access required.
        </Alert>
        <div className="text-center">
          <Button variant="primary" href="/">Return Home</Button>
        </div>
      </Container>
    );
  }

  return children;
}
